export default [
    {
		path: "/osce",
		component: () => import("../views/OSCE/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/settings/osce",
		component: () => import("../views/Settings/OSCE/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/settings/osce/edit/:id?",
		component: () => import("../views/Settings/OSCE/Edit.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/settings/osce/:osceid/stations/:id?",
		component: () => import("../views/Settings/OSCE/Station.vue"),
	},
    {
		path: "/settings/osce/:osceid/events/:id?",
		component: () => import("../views/Settings/OSCE/Event.vue"),
	},
    {
		path: "/osce/student",
		component: () => import("../views/OSCE/StudentDashboard.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/osce/schedule",
		component: () => import("../views/OSCE/Schedule.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/osce/examiner/:osceeventid?/:oscestationid?",
		component: () => import("../views/OSCE/ExaminerDashboard.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/osce/admin",
		component: () => import("../views/OSCE/AdminDashboard.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/osce/overview/examiners",
		component: () => import("../views/OSCE/Overview/Examiner.vue"),
		// meta: {
		// 	hasmainmenu: true
		// }
	},
	{
		path: "/osce/form/:formresponseid?",
		component: () => import("../views/OSCE/Form.vue"),
	},
	{
		path: "/oscegrading",
		component: () => import("../views/OSCE/Grading.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/oscestationtimer/:id",
		component: () => import("../views/OSCE/StationTimer.vue"),
	}
]
